import diccionarioColores from '@/assets/data/diccionario-colores.json';
import FichasA from '@/assets/datasets/consorcio_fichas_a.json';
import FichasB from '@/assets/datasets/consorcio_fichas_b.json';

const diccionariosFichas = FichasA.reduce((accumulate, current) => {
  const accum = accumulate;
  if (!(current.cve_edo in accum)) {
    accum[current.cve_edo] = { nom_edo: current.estado, variantes: { } };
  }
  if (!(current.tipo_variante in accum[current.cve_edo].variantes)) {
    accum[current.cve_edo].variantes[current.tipo_variante] = {
      color: diccionarioColores[current.tipo_variante].color,
      title: diccionarioColores[current.tipo_variante].title,
      title2: diccionarioColores[current.tipo_variante].title2,
      oms_labels: [],
      oms_counts: [],
      oms_percents: [],
      oms_colores: [],
      oms_conteo_variantes: 0
    };
  }

  accum[current.cve_edo].variantes[current.tipo_variante].cantidad = current.cantidad_variantes;
  accum[current.cve_edo].variantes[current.tipo_variante].presencia = `${current.presencia_municipal_estatal} ${current.cve_edo === '00' ? 'estados ' : 'municipios'}`;
  return accum;
}, { });


FichasB.sort((a,b)=>b.cantidad_muestras - a.cantidad_muestras).forEach((element) => {
  const tipoVariante = diccionariosFichas[element.cve_edo].variantes[element.tipo_variante];
  //Dejando que solo 5 variantes se agregen a la lista (independientemente que haya mas)
  if (tipoVariante.oms_labels.length <= 4) {
    tipoVariante.oms_labels.push(element.variante_oms);
    tipoVariante.oms_counts.push(element.cantidad_muestras);
    tipoVariante.oms_percents.push(element.porcentaje_muestras);
    // const nombreTipo = element.variante_oms;
    const color = 'variantes' in diccionarioColores[element.tipo_variante]
      ? diccionarioColores[element.tipo_variante].variantes[element.variante_oms]
      : diccionarioColores[element.tipo_variante].color;

    tipoVariante.oms_colores.push(color);
  }
  tipoVariante.oms_conteo_variantes++;
});

export default diccionariosFichas;
